import apiDashboard from '../../../api/dashboardAll';
import apiOption from '@/api/option';

const defaultState = () => ({
	listStatusSales: [],
	listTotalSales: [],
	listTotalPurchase: [],
	listResumeStock: [],
	listSalesProduct: [],
	listTopProduct: [],
	listSalesPurchase: [],
	listSalesProductWeekly: {day_arr: {}, results: []},
	listSalesPriceWeekly: {day_arr: [], results: []},
	listSalesRetailPriceWeekly: {day_arr: [], results: []},
	listSalesRetailWeekly: {day_arr: {}, results: []},
	optionProduct: [],
	optionMainProduct: [],
	optionWarehouse: [],
});

const state = defaultState();

const getters = {

};

const mutations = {

	setStatusSales(state, data) {
		state.listStatusSales = data.data;
	},
	setTotalSales(state, data) {
		state.listTotalSales = data.data;
	},
	setTotalPurchase(state, data) {
		state.listTotalPurchase = data.data;
	},
	setResumeStock(state, data) {
		var stock = [];
		data.data.forEach((el) => {
			el.warehouse_stock.forEach((element) => {
				element['warehouse_id'] = el.warehouse_id,
				element['warehouse_name'] = el.warehouse_name,
				stock.push(element)
			})
		})
		state.listResumeStock = stock;
	},
	setSalesProduct(state, data) {
		state.listSalesProduct = data.data;
	},
	setTopProduct(state, data) {
		state.listTopProduct = data.data;
	},
	setSalesPurchase(state, data) {
		state.listSalesPurchase = data.data;
	},
	setOptionProduct(state, data) {
		state.optionProduct = data
	},
	setOptionMainProduct(state, data) {
		state.optionMainProduct = data
	},
	setOptionWarehouse(state, data) {
		state.optionWarehouse = data
	},
	setSalesProductWeekly(state, data) {
		state.listSalesProductWeekly = {day_arr: data.day_arr, results: data.results};
	},
	setSalesRetailWeekly(state, data) {
		state.listSalesRetailWeekly = {day_arr: data.day_arr, results: data.results};
	},
	setSalesPriceWeekly(state, data) {
		let res = {day_arr: Object.keys(data), results: Object.values(data)};
		state.listSalesPriceWeekly = res;
	},
	setSalesRetailPriceWeekly(state, data) {
		let res = {day_arr: Object.keys(data), results: Object.values(data)};
		state.listSalesRetailPriceWeekly = res;
	},
};

const actions = {
	getStatusSales({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getStatusSales(params).then(({ data: { data } }) => {
				commit('setStatusSales', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setStatusSales', { data: [] });
			});
		});
	},
	getTotalSales({ commit }, params) {
		apiDashboard.getTotalSales(params).then(({ data: { data } }) => {
			commit('setTotalSales', { data: data.results });
		}).catch(() => {
			commit('setTotalSales', { data: [] });
		});
	},
	getTotalPurchase({ commit }, params) {
		apiDashboard.getTotalPurchase(params).then(({ data: { data } }) => {
			commit('setTotalPurchase', { data: data.results });
		}).catch(() => {
			commit('setTotalPurchase', { data: [] });
		});
	},
	async getResumeStock({ commit }, params) {
		await apiDashboard.getResumeStock(params).then(({ data: { data } }) => {
			commit('setResumeStock', { data: data.results });
		}).catch(() => {
			commit('setResumeStock', { data: [] });
		});
	},
	getSalesProduct({ commit }, params) {
		apiDashboard.getSalesProduct(params).then(({ data: { data } }) => {
			commit('setSalesProduct', { data: data.results });
		}).catch(() => {
			commit('setSalesProduct', { data: [] });
		});
	},
	getTopProduct({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getTopProduct(params).then(({ data: { data } }) => {
				commit('setTopProduct', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setTopProduct', { data: [] });
			});
		});
	},
	getSalesPurchase({ commit }, params) {
		return new Promise((resolve) => {
			apiDashboard.getSalesPurchase(params).then(({ data: { data } }) => {
				commit('setSalesPurchase', { data: data.results });
				resolve()
			}).catch(() => {
				commit('setSalesPurchase', { data: [] });
			});
		});
	},
	getOptionProduct({ commit }){
		apiOption.getOptionProduct().then( ({ data: { data } }) => {
			commit('setOptionProduct', data.results);
		}).catch(() => {
			commit('setOptionProduct', []);
		});
	},
	getOptionProductMain({ commit }) {
		return new Promise((resolve) => {
			apiOption.getOptionProductMain().then(({ data: { data } }) => {
				commit('setOptionMainProduct', data.results);
				resolve(data.results)
			}).catch(() => {
				commit('setOptionMainProduct', { data: [] });
			});
		});
	},
	getOptionWarehouse({ commit }){
		apiOption.getOptionWarehouseAll().then( ({ data: { data } }) => {
			commit('setOptionWarehouse', data.results);
		}).catch(() => {
			commit('setOptionWarehouse', []);
		});
	},
	getSalesProductWeekly({ commit }, params) {
		apiDashboard.getSalesProductWeekly(params).then(({ data: { data } }) => {
			commit('setSalesProductWeekly', data);
		}).catch(() => {
			commit('setSalesProductWeekly', {day_arr: {}, results: []});
		});
	},
	getSalesPriceWeekly({ commit }, params) {
		apiDashboard.getSalesPriceWeekly(params).then(({ data: { data } }) => {
			commit('setSalesPriceWeekly', data.results);
		}).catch(() => {
			commit('setSalesPriceWeekly', {});
		});
	},
	getSalesRetailWeekly({ commit }, params) {
		apiDashboard.getSalesRetailWeekly(params).then(({ data: { data } }) => {
			commit('setSalesRetailWeekly', data);
		}).catch(() => {
			commit('setSalesRetailWeekly', {});
		});
	},
	getSalesRetailPriceWeekly({ commit }, params) {
		apiDashboard.getSalesRetailPriceWeekly(params).then(({ data: { data } }) => {
			commit('setSalesRetailPriceWeekly', data.results);
		}).catch(() => {
			commit('setSalesRetailPriceWeekly', {});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};